module.exports = __webpack_public_path__ + "static/media/winter_super_pack_dog_bed_EN.9a6a616d.png";